"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _getCountryOptions = require("./getCountryOptions");

var phoneOptions = [];

var _default = function _default(phoneData) {
  if (phoneOptions.length) {
    return phoneOptions;
  }

  var countryOptions = (0, _getCountryOptions.getCountryOptions)();
  phoneOptions = countryOptions.filter(function (option) {
    return phoneData.find(function (c) {
      return c.iso2 === option.value;
    });
  }).map(function (option) {
    var dialCode = phoneData.find(function (c) {
      return c.iso2 === option.value;
    }).dialCode;
    return (0, _extends2.default)({}, option, {
      text: option.text + " +" + dialCode
    });
  });
  return phoneOptions;
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.3462/js/internal/utils/getPhoneOptions.js
// module id = 639
// module chunks = 5 6